export default __webpack_public_path__ + "static/media/BasicPublic3.82707aff.png";